import React from "react";
import image1 from "../assets/knackfeed.png";
import image2 from "../assets/knackmoments.png";
import image3 from "../assets/Kv.png";

const About = () => {
  return (
    <div className="about-area inc-shape default-padding">
      <div className="container">
        <div className="row">
          {/* Image Column */}
          <div className="col-lg-6 col-sm-12 ">
            <div className="thumb position-relative">
              <img
                decoding="async"
                src={image3}
                alt="Thumb 1"
                className="img-fluid" 
                style={{
                  borderRadius: '20px',
                  boxShadow: '0 0 10px #cccccc'
                }}// added to make the image responsive
              />
              <img
                decoding="async"
                src={image2}
                alt="Thumb 2"
                className="img-fluid second-image" 
                style={{
                  borderRadius: '20px',
                  boxShadow: '0 0 10px #cccccc'
                }}// added to make the image responsive
              />
              <div className="overlay">
               
                  {/*<h4>AI Driven Automation</h4>*/}
                  <img
                decoding="async"
                src={image1}
                alt="Thumb 2"
                className="img-fluid" 
                style={{height:'250px',width:'250px'}}// added to make the image responsive
              />
               
              </div>
            </div>
          </div>

          {/* Text Content Column */}
          <div className="col-lg-4 offset-lg-1 info">
            <h2>Fueling Authentic Brand Growth with AI-Driven Automation</h2>
            <p>
              KnackVibes is an AI-powered personal branding tool that enhances LinkedIn presence with AI-based content generation, automated post scheduling, and intelligent engagement tracking.
              It also supports social media branding Agencies by managing multiple clients on a single platform.
            </p>
            <ul className="list-icons">
              <li>
                <div className="icon">
                  <i className="fa fa-refresh" style={{ fontSize: 36, color: "#2e3192", marginBottom: 20 }}></i>
                </div>
                <div className="info">
                  <p>AI-driven content generation and scheduling.</p>
                </div>
              </li>
              <li>
                <div className="icon">
                  <i className="fa fa-user" style={{ fontSize: 36, color: "#2e3192", marginBottom: 20 }}></i>
                </div>
                <div className="info">
                  <p>Multi-client management for Agencies with centralized control.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <style jsx>{`
        .about-area .info h2 {
          font-weight: 600;
          margin-bottom: 25px;
        }

        .default-padding {
          padding-top: 60px;
          padding-bottom: 60px;
        }

        .about-area .thumb {
          position: relative;
        }

        .about-area .thumb .overlay {
          position: absolute;
          right: 0;
          top: 50%;
          height: 250px;
          width: 250px;
          text-align: center;
          background: #ffffff;
          transform: translate(50px, -50%);
          border-radius: 8px;
          box-shadow: 0 0 10px #cccccc;
        }

        .about-area .thumb .second-image {
          position: relative;
          left: 20%;
          width: 68%;
          top: -80px;
          margin-bottom: -80px;
          box-shadow: 0 0 10px #cccccc;
          padding: 5px;
          background: #ffffff;
        }

        .about-area .thumb img {
          border-radius: 8px;
        }

        .about-area .thumb img.img-fluid {
          max-width: 100%; /* Ensures image is responsive */
          height: auto;
        }

        .about-area .thumb .overlay .content {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          padding: 0 30px;
        }

        .about-area .thumb .overlay h4 {
          margin: 0;
          position: relative;
          font-weight: 700;
          text-transform: capitalize;
          line-height: 1.4;
        }

        .about-area .info h2 {
          font-weight: 600;
          margin-bottom: 25px;
          color: #2e3192;
          margin-top: 80px;
        }

        .about-area .info ul {
          margin-top: 30px;
          list-style: none;
        }

        .about-area .info ul li {
          display: flex;
          align-items: center;
        }

        .about-area .info .icon {
          margin-right: 15px;
        }

        /* Media Queries for responsiveness */
        @media (max-width: 992px) {
          .about-area .info h2 {
            font-size: 28px;
          }

          .about-area .thumb .second-image {
            left: 0;
            width: 100%;
            top: 0;
            margin-bottom: 0;
            box-shadow: none;
          }

          .about-area .thumb {
            text-align: center;
          }

          .about-area .info {
            margin-top: 20px;
          }
        }

        @media (max-width: 768px) {
          .about-area .info h2 {
            font-size: 24px;
            margin-top: 50px;
          }

          .about-area .info ul {
            margin-top: 20px;
          }

          .about-area .info ul li {
            font-size: 14px;
          }

          .about-area .thumb .overlay {
            width: 200px;
            height: 200px;
            top: 40%;
            transform: translate(20px, -40%);
          }

          .about-area .thumb img {
            width: 100%;
            margin-bottom: 20px;
          }

          .about-area .thumb .overlay h4 {
            font-size: 18px;
          }
        }
@media (max-width: 576px) {
  .default-padding {
    padding-bottom: 100px; /* Increased from 60px to 100px */
  }

  .about-area .info h2 {
    font-size: 20px;
  }

  .about-area .thumb .overlay {
    width: 150px;
    height: 150px;
    top: 40%;
    transform: translate(-39px, -40%);
  }

  .about-area .thumb img {
    width: 100%;
  }

  .about-area .info ul li {
    font-size: 12px;
  }
}
        @media (max-width: 576px) {
          .about-area .info h2 {
            font-size: 20px;
          }

          .about-area .thumb .overlay {
            width: 150px;
            height: 150px;
            top: 40%;
            transform: translate(-39px, -40%);
          }

          .about-area .thumb img {
            width: 100%;
          }

          .about-area .info ul li {
            font-size: 12px;
          }

        }
      `}</style>
    </div>
  );
};

export default About;
